import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconPlace from '@/icons/Place.svg';

export const ArticleSubLocationClearedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'article_sub_location_cleared'>;
}) => {
  const creatorName = activity.creator?.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      icon={<IconPlace deleted />}
      type="danger"
      message={
        <BaseActivityText>
          {creatorName ? (
            <Trans id="activities.article_sub_location_cleared.message">
              <strong>{creatorName}</strong> cleared the sub-location
            </Trans>
          ) : (
            <Trans id="activities.article_sub_location_cleared.message.automatic">
              Sub-location has been automatically cleared
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
